import { Button, ButtonLink, Divider, Flex, Heading, Text, useToasts } from '@applyboard/crystal-ui';
import { CopyOutlineIcon, ShoppingCartOutlineIcon } from '@applyboard/ui-icons';
import { copyToClipboard, useTranslation } from '@applyboard/ui-utils';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export function PaymentPrompt(_ref) {
  var paymentLink = _ref.paymentLink,
    onEvent = _ref.onEvent;
  var toasts = useToasts();
  var _useTranslation = useTranslation('PaymentPrompt'),
    t = _useTranslation.t;
  return _jsxs(Flex, {
    gap: 8,
    children: [_jsxs(Flex, {
      direction: "column",
      gap: 2,
      children: [_jsx(Heading, {
        level: 3,
        variant: "labelL",
        children: t('payNowHeading')
      }), _jsx(Text, {
        children: t('payNowDescription')
      }), _jsx(Flex.Item, {
        children: _jsx(ButtonLink, {
          href: paymentLink,
          mode: "override_user_choice_and_open_in_new_tab",
          leadIcon: ShoppingCartOutlineIcon,
          intent: "primary",
          emphasis: "outlined",
          width: "hug",
          onClick: function onClick() {
            onEvent === null || onEvent === void 0 ? void 0 : onEvent('clicked_pay_via_flywire');
          },
          children: t('payNowCtaText')
        })
      })]
    }), _jsx(Divider, {
      direction: "vertical",
      children: t('or')
    }), _jsxs(Flex, {
      direction: "column",
      gap: 2,
      children: [_jsx(Heading, {
        level: 3,
        variant: "labelL",
        children: t('askSomeoneHeading')
      }), _jsx(Text, {
        children: t('askSomeoneDescription')
      }), _jsx(Flex.Item, {
        children: _jsx(Button, {
          leadIcon: CopyOutlineIcon,
          intent: "primary",
          emphasis: "outlined",
          width: "hug",
          onClick: function onClick() {
            copyToClipboard(paymentLink).then(function () {
              toasts.positive('Payment link copied to clipboard');
            });
            onEvent === null || onEvent === void 0 ? void 0 : onEvent('copied_payment_link');
          },
          children: t('askSomeoneCtaText')
        })
      })]
    })]
  });
}